module.exports = __webpack_public_path__ + "img/motorway_4x4_z16.584cc7d9.svg";